const BASE_URL = process.env.REACT_APP_RBAC_REST_API_URL ?? '';

const API_URL = `${BASE_URL}/tenantRoles`;

const ROUTES: Record<string, string> = {
	ALL_ROLES: `${API_URL}/customRoles`,
}

export default ROUTES